export default __webpack_public_path__ + "static/webRotator/svg/5e9d37f3397de9af0ca0c93146f816d6.svg";